import { Reveal, Eyebrow } from "./Reveal";

const PALAZZO_IMG = "/images/sala.jpg";

const chapters = [
  {
    n: "01",
    title: "Le pareti gialle e i quadri",
    text: "I quadri dialogano con le pareti gialle delle sale, come nelle case piemontesi di una volta: un teatro domestico per la tavola della sera.",
  },
  {
    n: "02",
    title: "Arredi sobri, calore di famiglia",
    text: "Niente ostentazione: arredi sobri, tovaglie curate e una cucina che parla la lingua del territorio, stagione dopo stagione.",
  },
];

const Storia = () => (
  <section id="storia" className="py-24 lg:py-36">
    <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16">
      <div className="grid lg:grid-cols-12 gap-12 lg:gap-8">
        <div className="lg:col-span-5">
          <Reveal>
            <Eyebrow>La nostra storia</Eyebrow>
            <h2 className="mt-6 font-serif-display font-medium text-3xl sm:text-4xl lg:text-5xl leading-tight tracking-tight" data-testid="storia-title">
              Un palazzo, tre sale, una sola cucina: <em className="text-[#7A1C28]">quella piemontese.</em>
            </h2>
          </Reveal>
          <Reveal delay={0.15} className="mt-10">
            <div className="frame-clip overflow-hidden aspect-[4/5] max-w-md">
              <img
                src={PALAZZO_IMG}
                alt="Interno del palazzo ottocentesco con quadri alle pareti gialle"
                className="h-full w-full object-cover hover:scale-105 transition-transform duration-[1.4s] ease-out"
                loading="lazy"
              />
            </div>
          </Reveal>
        </div>
        <div className="lg:col-span-6 lg:col-start-7 flex flex-col justify-center divide-y divide-[#E7E4DF]">
          {chapters.map((c, i) => (
            <Reveal key={c.n} delay={i * 0.12} className="py-10 first:pt-0 last:pb-0">
              <div className="flex items-baseline gap-6" data-testid={`storia-chapter-${c.n}`}>
                <span className="font-mono-accent text-sm text-[#B87F1B]">{c.n}</span>
                <div>
                  <h3 className="font-serif-display text-xl sm:text-2xl font-medium">{c.title}</h3>
                  <p className="mt-3 text-base leading-relaxed text-[#6E6A66] font-light max-w-lg">{c.text}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default Storia;
